import {
  useFeatureFlagEnabled,
  useFeatureFlagVariantKey,
} from 'posthog-js/react';

export const useAbTestSearch = () => {
  const abTestName = 'abTestSearch';
  const abTestVariant = useFeatureFlagVariantKey(abTestName);
  const isAbTestSearchEnabled = useFeatureFlagEnabled(abTestName);

  const isAbTestSearchLoaded =
    !!abTestVariant || isAbTestSearchEnabled !== undefined;
  const isAbTestSearchControlVariant = abTestVariant === 'control';
  const isAbTestSearchNoStepVariant =
    abTestVariant === 'abTestSearchNoStepVariant';
  const isAbTestSearchNoStepNoDescriptionVariant =
    abTestVariant === 'abTestSearchNoStepNoDescriptionVariant';
  const isAbTestSearchNoStepNoDescriptionNoTitleVariant =
    abTestVariant === 'abTestSearchNoStepNoDescriptionNoTitleVariant';

  return {
    isAbTestSearchLoaded,
    isAbTestSearchEnabled,
    isAbTestSearchControlVariant,
    isAbTestSearchNoStepVariant,
    isAbTestSearchNoStepNoDescriptionVariant,
    isAbTestSearchNoStepNoDescriptionNoTitleVariant,
  };
};
